export default {
  full_name: 'Personal Info',
  tagline: 'Personal Info',
  email: 'Personal Info',
  phone_number: 'Personal Info',
  address: 'Personal Info',
  personal_link: 'Personal Info',
  objective: 'Personal Info',

  work_experience_organization: 'Work Experience',
  work_experience_organization_details: 'Work Experience',
  work_experience_role_details: 'Work Experience',
  work_experience_from: 'Work Experience',
  work_experience_to: 'Work Experience',

  education_organization: 'Education',
  education_organization_details: 'Education',
  education_role_details: 'Education',
  education_from: 'Education',
  education_to: 'Education',

  awards_and_honors_organization: 'Awards & Honors',
  awards_and_honors_organization_details: 'Awards & Honors',
  awards_and_honors_role_details: 'Awards & Honors',
  awards_and_honors_issue_date: 'Awards & Honors',

  volunteer_work_organization: 'Volunteer Work',
  volunteer_work_organization_details: 'Volunteer Work',
  volunteer_work_role_details: 'Volunteer Work',
  volunteer_work_from: 'Volunteer Work',
  volunteer_work_to: 'Volunteer Work',

  certifications_organization: 'Certifications',
  certifications_organization_details: 'Certifications',
  certifications_role_details: 'Certifications',
  certifications_from: 'Certifications',
  certifications_to: 'Certifications',

  projects_organization: 'Projects',
  projects_organization_details: 'Projects',
  projects_role_details: 'Projects',
  projects_from: 'Projects',
  projects_to: 'Projects',

  research_experience_organization: 'Research Experience',
  research_experience_organization_details: 'Research Experience',
  research_experience_role_details: 'Research Experience',
  research_experience_from: 'Research Experience',
  research_experience_to: 'Research Experience',

  leadership_organization: 'Leadership',
  leadership_organization_details: 'Leadership',
  leadership_role_details: 'Leadership',
  leadership_from: 'Leadership',
  leadership_to: 'Leadership',

  associations_organization: 'Associations',
  associations_organization_details: 'Associations',
  associations_role_details: 'Associations',
  associations_from: 'Associations',
  associations_to: 'Associations',

  extra_curricular_organization: 'Extra Curricular Activities',
  extra_curricular_organization_details: 'Extra Curricular Activities',
  extra_curricular_role_details: 'Extra Curricular Activities',
  extra_curricular_from: 'Extra Curricular Activities',
  extra_curricular_to: 'Extra Curricular Activities',

  courses_organization: 'Courses',
  courses_organization_details: 'Courses',
  courses_role_details: 'Courses',
  courses_completion_date: 'Courses',

  conferences_organization: 'Conferences/Presentations',
  conferences_organization_details: 'Conferences/Presentations',
  conferences_role_details: 'Conferences/Presentations',
  conferences_date: 'Conferences/Presentations',

  references_organization: 'References',
  references_organization_details: 'References',
  references_role_details: 'References',

  patents_organization: 'Patents',
  patents_organization_details: 'Patents',
  patents_role_details: 'Patents',
  patents_patent_date: 'Patents',

  test_scores_organization: 'Test Scores',
  test_scores_organization_details: 'Test Scores',
  test_scores_role_details: 'Test Scores',
  test_scores_date: 'Test Scores',

  skill_organization: 'Skills',
  skill_organization_details: 'Skills',
  skill_organization_name: 'Skills',
  skill_title: 'Skills',
  skill: 'Skills',

  publication: 'Publications',

  language: 'Languages',

  hobbies_and_interests: 'Hobbies & Interests',

  summary: 'Summary',
};
